module.exports = __webpack_public_path__ + "static/media/a-5-c.fcfd0067.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/accessroies/a-5-c.jpg
// module id = 1105
// module chunks = 33